import React, {Component} from 'react'
import BackOfficeMenuComponent from '../components/BackOfficeMenuComponent'
import BackOfficeNavMenuComponent from '../components/BackOfficeNavMenuComponent'
import './BackOfficeNavigatorScreen.css'

export default class BackOfficeNavigatorScreen extends Component {
  render () {
    return (
      <div>
        <div className="backoffice">
          <div className="row">
            <BackOfficeNavMenuComponent onMarksWaitingClick={() => {this.props.onMarksWaitingClick()}} {...this.props} />
            <div className="col-sm-2 main-content">
              <BackOfficeMenuComponent />
            </div>
            <div className="col-sm-10 sidebar-right">
              {this.props.children}
            </div>
          </div>
        </div>
      </div>

    );
  }
}


// WEBPACK FOOTER //
// ./src/screens/BackOfficeNavigatorScreen.js